
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`Phase III: Vous tombez malade`}</h3>
    <p>{`Le `}<strong parentName="p">{`vendredi`}</strong>{`, après la période d'incubation de cinq à six jours en général,
vous ressentez les `}<strong parentName="p">{`premiers symptômes`}</strong>{`: maux de tête, légère toux et perte de
goût. Par mesure de précaution, vous allez consulter votre médecin. `}<strong parentName="p">{`Le test
est positif`}</strong>{` et, quelques heures plus tard, vous recevrez l'ordre de rester en
isolement strict à la maison. Tous les membres de votre ménage reçoivent
également l'obligation de se placer en quarantaine.`}</p>
    <p><strong parentName="p">{`Dehors, la vie continue – mais sans vous.`}</strong></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;